import { gql } from '@apollo/client';

export const GET_I4_LINK_STATUS = gql`
  query GetI4LinkStatus($societyCode: String!) {
    i4LinkStatus(societyCode: $societyCode) {
      userI4LinkId
      societyCode
      societyId
      memberId
      memberIdent
      isValidated
      tokenExpiresAt
      createdDate
      modifiedDate
    }
  }
`;

export const GET_I4_REDIRECT_URL = gql`
  query GetI4RedirectUrl($input: I4RedirectUrlQueryInput!) {
    i4RedirectUrl(input: $input)
  }
`;

export const GET_I4_DOWNLOADS = gql`
  query GetI4Downloads($societyCode: String!) {
    i4Downloads(societyCode: $societyCode) {
      documentId
      documentGuid
      fileName
      url
      documentSize
      createdDate
      modifiedDate
    }
  }
`;

export const GET_I4_GUEST_REDIRECT_URL = gql`
  query GetI4GuestRedirectUrl($input: I4GuestRedirectUrlQueryInput!) {
    i4GuestRedirectUrl(input: $input)
  }
`;

export const GET_I4_LINK_URL = gql`
  query GetI4LinkUrl($input: I4LinkUrlQueryInput!) {
    i4LinkUrl(input: $input)
  }
`;

export const GET_I4_LINKS = gql`
  query GetI4Links {
    i4Links {
      userI4LinkId
      societyCode
      societyId
      memberId
      memberIdent
      isValidated
      tokenExpiresAt
      createdDate
      modifiedDate
    }
  }
`;
